import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getFreeUsers, updateFreeUser } from '../../actions';

class FreeUser extends Component {

  state = {
    search: '',
    email: '',
    usersAll: [],
    users: []
  }

  componentWillMount = () => {
    this.props.getFreeUsers();
  }

  componentWillReceiveProps = (nextProps) => {
    if(nextProps.freeUsers) {
      this.setState({
        usersAll: nextProps.freeUsers,
        users: nextProps.freeUsers
      })
    }

    if(nextProps.updateUser) {
      this.props.getFreeUsers()
    }
  }

  handleChange = (evt) => {
    const value = evt.target.value;
    const name = evt.target.name;
    
    this.setState({
      ...this.state,
      [name]: value
    });

    if(evt.target.name === 'search') {
      this.setState({
        users: this.state.usersAll.filter(
          user => user.email && user.email.includes(value)
          )
      })
    }

  }

  submitForm = async (e) => {
    e.preventDefault();
    await this.props.updateFreeUser(this.state.email);

    this.setState({
      email: '',
      search: ''
    })
  }

  renderFreeUsers = () => (
    this.state.users ?
    this.state.users.filter(user => user.email).map((user, i) => {
      return <div key={i} className="inline-row inline-row-motivation">
        <div className="column-motivation hover">{ user.email || user._id }</div>
      </div>
    })  : null
  )
  

  render() {
    return (
      <div>
        <div className="inline">
          <div className="motivation-div oneColume-div">
            <h2 className="headline">Free Users</h2>
            <div className="block">
            <input type="text" placeholder="Search"  name="search" value={this.state.search} onChange={this.handleChange} className="search-oneColumn select-motivation search-input"/>
            </div>
            <div className="specific-feedbacks-head inline-row inline-row-motivation">
              <div className="column-motivation column-head">Email</div>
            </div>
            <div className="specific-feedbacks">
              <div className="names">{this.renderFreeUsers()}</div>
            </div>
          </div>
            <form onSubmit={this.submitForm} className="freeUser-form add-form"> 
              <div style={{display: 'grid'}}>
                <h2 className="headline">Add Free User</h2>
              <input 
                    name="email"
                    type="text"
                    className="input input-motivation"
                    placeholder="Email"
                    value={this.state.email}
                    onChange={this.handleChange}
                />
                </div>
              <button type="submit" className="savebtn" onClick={this.submitForm}>Save</button> 
            </form>
        </div>
      </div>
    );
  }
}

function mapStateToProps (state) {
  return {
    updateUser: state.user.updateFreeUser,
    freeUsers: state.user.freeUsers ? state.user.freeUsers.free: null,
    notFreeUsers: state.user.freeUsers ? state.user.freeUsers.notFree: null
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({ getFreeUsers, updateFreeUser },dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(FreeUser);